<ng-container>
  <div
    data-test="AyMXDd5L"
    class="schedule-scale-track scrollbar-thin scrollbar-horizontal"
    data-simplebar
  >
    <div data-test="etinP43P" class="schedule-scale">
      <div data-test="6G7plhUp" class="schedule-scale__days d-block text-nowrap">
        <div
          data-test="AcTKTaok"
          class="schedule-scale__day d-inline-block align-top"
          *ngFor="let item of items; let i = index; last as isLast"
          [class.begin]="i === 0"
          [style.color]="item.color"
          [style.width.%]="item.durationPercent"
        >
          <div data-test="dEAFnSLf" class="d-flex">
            <div data-test="rACKzouR">
              <div data-test="sUrZcfG6" class="hours text-small">
                {{ item.startTime | time: 'HH:mm' }}
              </div>
            </div>
            <div data-test="21ICPNy3" class="mr-3 ml-auto" *ngIf="isLast">
              <div data-test="FhSPbE35" class="hours text-small">
                {{ item.endTime | time: 'HH:mm' }}
              </div>
            </div>
          </div>
          <div data-test="OU3QqbEL" class="schedule-scale__day-progress">
            <div data-test="zgWdhh2y" class="line"></div>
          </div>
          <div data-test="yF9K8Z4O" class="schedule-scale__day-info">
            <div data-test="SZGPhGad" class="assignment">
              {{ item.name }}
            </div>
            <div data-test="G_6PlbAV" class="type text-light text-small">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div data-test="tLlz6Blf" class="schedule-team__planner-table">
    <table data-test="54W4-OwN" class="items-table">
      <tr data-test="vrY2ZFiM" class="items-table__header items-table__header_fs-9">
        <th data-test="eJ7-FHWc">
          <span data-test="dC-UjIDW" class="mr-2">ASSIGNMENT</span>
        </th>
        <th data-test="OcKDpvZ8">
          <span data-test="gNUiz_fi" class="mr-2">START TIME</span>
        </th>
        <th data-test="j9M0dWn_">
          <span data-test="Mk3Z8Kyg" class="mr-2">END TIME</span>
        </th>
        <th data-test="mmVdkuQR">
          <span data-test="MfdIZHhO" class="mr-2">DURATION</span>
        </th>
        <th data-test="X0-GkGNZ">
          <span data-test="VyBN5mpx" class="mr-2">START LOCATION</span>
        </th>
      </tr>

      <tr data-test="v2nLIpoY" *ngFor="let assignment of items" class="row-type">
        <td data-test="WCg-907O" [style.border-left-color]="assignment.color">
          <b data-test="aRQtCzwM" class="text-normal">
            {{ assignment.name }}
          </b>
          <div data-test="Gt-jVii5">
            {{ assignment.startTime | time: 'HH:mm' }} –
            {{ assignment.endTime | time: 'HH:mm' }} ({{
              minutesToText(assignment.duration)
            }})
          </div>
        </td>
        <td data-test="ibNrHT5z">{{ assignment.startTime | time: 'HH:mm' }}</td>
        <td data-test="HFVjK9tE">{{ assignment.endTime | time: 'HH:mm' }}</td>
        <td data-test="PkmmlmWa">
          {{ toTime(assignment.duration) | time: 'HH:mm':false }}
        </td>
        <td data-test="oCQhkl-w">{{ assignment.label }}</td>
      </tr>
    </table>
  </div>
</ng-container>
